<template>
    <div>
        <h2 class="text-lg-h5 font-weight-bold">Homepage</h2>
        <div class="my-6">
            <v-row>
                <v-col class="pa-0">
                    <div v-if="blockedSites.length === 0" class="mx-3">
                        <AvatarCard :item="null"></AvatarCard>
                    </div>
                    <div class="blockedSitesContainer d-flex flex-row mx-3" v-else>
                        <div class="text-h6 mt-4 mr-6">Aktivitäten:</div>
                        <div class="d-flex flex-wrap">
                            <div v-for="(user, i) in blockedSites" :key="user.usermail" style="">
                                <AvatarCard :item="user" :index="i"></AvatarCard>
                            </div>
                        </div>
                    </div>
                </v-col>
            </v-row>
            <v-divider class="my-10"></v-divider>
            <v-row>
                <v-col>
                    <Datatable class="px-4" title="Deployments" :headers="vuexState.deploymentTable.headers"
                               :items="deployments">
                    </Datatable>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import ada from '../scss/ada_colors.scss';
import AvatarCard from "../components/AvatarCard";
import Datatable from "../components/Tables/Datatable";

export default {
    name: 'Home',
    components: {Datatable, AvatarCard},
    data: () => {
        return {
            getDashboardInterval: null,
            ada
        }
    },
    mounted() {
        this.$store.dispatch('home/fetchDashboard');
        this.getDashboardInterval = setInterval(() => {
            if (this.$route.name === 'home' && (this.ssoLoginRes === null || this.ssoLoginRes.status !== 'redirect')) {
                this.$store.dispatch('home/fetchDashboard');
            }
        }, 3000)
    },
    beforeDestroy() {
        clearInterval(this.getDashboardInterval)
    },
    computed: {
        vuexState() {
            return this.$store.state.home;
        },
        deployments() {
            return this.$store.getters['home/deploymentsData'];
        },
        blockedSites() {
            return this.$store.getters['home/blockedSites'];
        },
        ssoLoginRes() {
            return this.$store.state.ssoLoginRes;
        }
    },
}
</script>

<style lang="scss" scoped>
.blockedSitesContainer {
    > div.flex:not(:last-child) {
        margin-bottom: 8px;
    }
}
</style>